import React from "react"
import clsx from "clsx"
import { Chip } from "@material-ui/core"
import { Cancel as CloseIcon } from "@material-ui/icons"

import { SparkleSingleIcon } from "@/assets/icons"

import { SvgIcon } from "@/components"

import { colors } from "@/styles/colors"

import useStyles from "@/components/Skynet/AttendanceSummary/SummarizeAttendanceButton/styles"

export type SummarizeAttendanceButtonProps = {
	label: string
	isActive?: boolean
	isPulsing?: boolean
	isCompact?: boolean
	disabled?: boolean
	onClick?: () => void
	onDelete?: () => void
}

const SummarizeAttendanceButton: React.FC<SummarizeAttendanceButtonProps> = (props) => {
	const {
		label,
		isActive,
		isPulsing,
		isCompact,
		disabled,
		onClick,
		onDelete
	} = props

	const classes = useStyles()

	const sparklesIconColor = isActive ? colors.gray[0] : colors.purple[500]

	const chipLabel = (
		<>
			<SvgIcon
				icon={SparkleSingleIcon}
				htmlColor={sparklesIconColor}
				autoSize
				className={classes.sparklesIcon}
			/>
			{!isCompact && label}
		</>
	)

	return (
		<Chip
			className={clsx({
				[classes.summaryChip]: true,
				[classes.activeChip]: Boolean(isActive),
				[classes.pulsingChip]: Boolean(isPulsing),
				[classes.compactChip]: Boolean(isCompact)
			})}
			classes={{
				label: clsx({
					[classes.summaryChipLabel]: true,
					[classes.summaryChipLabelCompact]: Boolean(isCompact)
				}),
				deleteIcon: classes.deleteIcon
			}}
			variant={isActive ? "default" : "outlined"}
			size="small"
			disabled={disabled}
			onClick={onClick}
			onDelete={onDelete}
			deleteIcon={<CloseIcon />}
			label={chipLabel}
			disableFocusRipple
		/>
	)
}

export default SummarizeAttendanceButton
